export const handleFieldChange = (
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  setState: React.Dispatch<React.SetStateAction<any>>,
) => {
  const { name, value } = e.target;

  setState((prevState: any) => ({
    ...prevState,
    [name]: value,
  }));
};
